import { Component, Input, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { PaginatorModule } from 'primeng/paginator';
import { TableModule } from 'primeng/table';
import { Product } from '../../../../models/product.model';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReportHeaderComponent } from '../../components/report-header/report-header.component';
import { SaleService } from '../../../../services/sale.service';
import { ActivatedRoute } from '@angular/router';
import { BestAndLeastSellingProduct } from '../dto/BestAndLeastSellingProduct.model';

@Component({
  selector: 'app-best-selling-products',
  imports: [
    PaginatorModule,
    ButtonModule,
    TableModule,
    DatePickerModule,
    CommonModule,
    FormsModule,
    ReportHeaderComponent
  ],
  templateUrl: './best-selling-products.component.html'
})
export class BestSellingProductsComponent implements OnInit{

  items: BestAndLeastSellingProduct[] = [];
  loading: boolean = true;
  first: number = 1;
  rows: number = 0
  totalRecords: number = 0;
  currentPage: number = 1;
  type: string = '';
  currentDate = new Date();
  initialDate: Date = this.currentDate;
  finalDate: Date = this.currentDate;

  constructor(private saleService: SaleService, private activatedRoute: ActivatedRoute)
  {


  }

  ngOnInit(): void {
    this.type = this.activatedRoute.snapshot.queryParamMap.get('type') ?? 'LEAST_SOLD';
    console.log(this.type);
    this.loading = false;

    this.getData();
  }


  onPageChange(event: any){
    this.first = event.first;
    this.currentPage = Math.floor(this.first / this.rows) + 1;
    this.getData();
  }

  getData =() => {
    this.loading = true;
        this.saleService.getBestAndLeastSold(this.type, this.initialDate, this.finalDate, this.currentPage).subscribe({
          next: (data) => {
            this.items = data.data;
            this.totalRecords = data.pagination.totalRecords;
            this.loading = false;
          },
          error: (error) => {
            console.log(error);
            this.loading = false;
          }
        });
    }

    onDateChange(dates: { initialDate: Date; finalDate: Date }){
      this.initialDate = dates.initialDate;
      this.finalDate = dates.finalDate;
    }

    export = () => {
        this.saleService.exportBestAndLeastSold(this.type, this.initialDate, this.finalDate).subscribe({
          next: (file) => {
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          },
          error: (error) => {
            console.log(error);
          }
        });
    }
}
